function rowOffsets(items, heights, defaultHeight = 46) {
    const offsets = [0];
    items.forEach(item => offsets.push(offsets[offsets.length - 1]
        + (heights[item.key] || (item.type === 'group' ? 29 : defaultHeight))));
    return offsets;
}

function rowAtOffset(offsets, value) {
    let low = 0;
    let high = offsets.length - 1;
    while (low < high) {
        const middle = Math.ceil((low + high) / 2);
        if (offsets[middle] <= value) low = middle;
        else high = middle - 1;
    }
    return Math.min(low, offsets.length - 2);
}

// Keep the window until its leading reserve drops to five rows. Refill three
// rows at a time while there is still content available for the next wheel tick.
function retainedWindow(offsets, top, height, direction = 1, previous = null) {
    const count = offsets.length - 1;
    if (!count) return {start: 0, end: 0};
    const first = rowAtOffset(offsets, Math.max(0, top));
    const last = rowAtOffset(offsets, Math.max(0, top) + height) + 1;
    const ahead = direction < 0 ? first - (previous ? previous.start : 0)
        : (previous ? previous.end : count) - last;
    const atEdge = previous && (direction < 0 ? previous.start === 0 : previous.end === count);
    if (previous && previous.start <= first && previous.end >= last && previous.end <= count
        && previous.end - previous.start <= last - first + 12 && (atEdge || ahead > 5)) return previous;
    return {start: Math.max(0, first - (direction < 0 ? 8 : 4)),
        end: Math.min(count, last + (direction < 0 ? 4 : 8))};
}

function visibleSegments(items, offsets, top, height, pinnedKey, overscan = 4) {
    const start = Math.max(0, rowAtOffset(offsets, Math.max(0, top)) - overscan);
    const end = Math.min(items.length, rowAtOffset(offsets, Math.max(0, top) + height) + overscan + 1);
    return segmentsInRange(items, offsets, {start, end}, pinnedKey);
}

function segmentsInRange(items, offsets, {start, end}, pinnedKey) {
    if (!items.length) return [];
    const indices = new Set();
    for (let index = start; index < Math.min(end, items.length); index += 1) indices.add(index);
    const pinnedKeys = Array.isArray(pinnedKey) ? pinnedKey : [pinnedKey];
    pinnedKeys.filter(Boolean).forEach(key => {
        const pinned = items.findIndex(item => item.key === key);
        if (pinned >= 0) indices.add(pinned);
    });
    const result = [];
    let cursor = 0;
    Array.from(indices).sort((a, b) => a - b).forEach(index => {
        // Keep boundary DOM nodes when the window moves by one row. Changing the
        // spacer key makes Vue move retained rows, blurring inputs and relaying out
        // the table even though only the first/last employee changed.
        if (index > cursor) result.push({type: 'spacer', key: cursor === 0 ? 'gap:start' : `gap:after:${items[cursor - 1].key}`,
            height: offsets[index] - offsets[cursor]});
        result.push(items[index]);
        cursor = index + 1;
    });
    if (cursor < items.length) result.push({type: 'spacer', key: 'gap:end', height: offsets[items.length] - offsets[cursor]});
    return result;
}

module.exports = {rowOffsets, rowAtOffset, retainedWindow, segmentsInRange, visibleSegments};
